import { Heart, BadgeCheck, MessageCircle } from "lucide-react";

const ITEMS = [
  {
    icon: Heart,
    title: "Local & Trusted",
    body: "Born and based in Mangawhai. Real people you can call when something doesn't feel right — not a faceless call centre.",
  },
  {
    icon: BadgeCheck,
    title: "Certified Installers",
    body: "Certified Panasonic Installer with 20+ years on the tools. Every install meets manufacturer spec, every time.",
  },
  {
    icon: MessageCircle,
    title: "Free Quotes & Honest Advice",
    body: "Straight-up advice on what your home or business actually needs — not the most expensive system on the shelf.",
  },
];

export default function WhyCoolWave() {
  return (
    <section className="py-16 md:py-20">
      <div className="container">
        <div className="mb-10 max-w-2xl">
          <h2 className="mb-3 text-3xl font-bold tracking-tight md:text-4xl">Why Cool Wave</h2>
          <p className="text-body">
            We're a small Northland team with a big focus on doing the job properly the first time.
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-3">
          {ITEMS.map(({ icon: Icon, title, body }) => (
            <div key={title} className="rounded-xl border border-border/60 bg-white p-6">
              <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-brand-50 text-brand">
                <Icon className="h-6 w-6" />
              </div>
              <h3 className="mb-2 text-lg font-semibold text-ink">{title}</h3>
              <p className="text-sm text-body">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
